import { useCallback, useRef } from 'react';

export function useScrollReveal() {
  const observerRef = useRef<IntersectionObserver | null>(null);

  const getObserver = () => {
    if (!observerRef.current) {
      observerRef.current = new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('revealed');
              observerRef.current?.unobserve(entry.target);
            }
          }),
        { threshold: 0.15 },
      );
    }
    return observerRef.current;
  };

  return useCallback((el: HTMLElement | null) => {
    if (el) getObserver().observe(el);
  }, []);
}
